export interface IUrlService {
  getUrlWithoutHostOrProtocol(): string;
  getUrlHost(): string;
  getCurrentUrl(): string;
}

const urlService: IUrlService = {
  getUrlHost: (): string => {
    return globalThis.location.host;
  },
  getUrlWithoutHostOrProtocol: (): string => {
    return globalThis.location.href.substring(
      globalThis.location.href.indexOf(globalThis.location.host) + globalThis.location.host.length,
    );
  },
  getCurrentUrl: (): string => {
    return globalThis.location.href;
  },
};

export default urlService;
